import AVdxbHeading from './index.vue';

AVdxbHeading.install = app => {
  app.component(AVdxbHeading.name, AVdxbHeading);
};

export default AVdxbHeading;
